import React, { Suspense, lazy } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { useMetaPixel } from '../hooks/useMetaPixel';
// Lazy load ALL below-fold components for performance
const SocialProof = lazy(() => import('../components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainPoints = lazy(() => import('../components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const WhatIncludes = lazy(() => import('../components/WhatIncludes').then(m => ({
  default: m.WhatIncludes
})));
const Benefits = lazy(() => import('../components/Benefits').then(m => ({
  default: m.Benefits
})));
const Offer = lazy(() => import('../components/Offer').then(m => ({
  default: m.Offer
})));
const Testimonials = lazy(() => import('../components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('../components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('../components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('../components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function LandingPage() {
  useMetaPixel();
  return <div className="w-full min-h-screen bg-[#0d0d0d] text-white selection:bg-[#F5C518] selection:text-black" data-id="element-273">
      <Navigation data-id="element-274" />
      <Hero data-id="element-275" />
      <Suspense fallback={null} data-id="element-276">
        <PurchasePopup data-id="element-277" />
      </Suspense>
      <Suspense fallback={<div className="min-h-[100px] bg-[#0d0d0d]" data-id="element-279" />} data-id="element-278">
        <SocialProof data-id="element-280" />
        <PainPoints data-id="element-281" />
        <WhatIncludes data-id="element-282" />
        <Benefits data-id="element-283" />
        <Offer data-id="element-284" />
        <Testimonials data-id="element-285" />
        <FAQ data-id="element-286" />
        <FinalCTA data-id="element-287" />
        <Footer data-id="element-288" />
      </Suspense>
    </div>;
}